var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                _vm._b({ staticClass: "p20" }, "el-col", _vm.gridl, false),
                [
                  _c("tree", {
                    attrs: {
                      "parent-tree": _vm.treeData,
                      "frame-id": _vm.frame_id,
                    },
                    on: { frameId: _vm.getFrameId, getList: _vm.handleTree },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                _vm._b(
                  { staticClass: "boder-left p20" },
                  "el-col",
                  _vm.gridr,
                  false
                ),
                [
                  _c("div", { staticClass: "table-box ml20" }, [
                    _c(
                      "div",
                      { staticClass: "header-16" },
                      [
                        _c(
                          "div",
                          { staticClass: "title-16" },
                          [
                            _vm._v("\n              员工列表\n              "),
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "right",
                                  trigger: "hover",
                                  "popper-class": "monitor-yt-popover",
                                },
                              },
                              [
                                _c("div", { staticClass: "prompt-bag" }, [
                                  _c("p", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.$t("setting.group.text")) +
                                        "\n                    "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "#1890ff",
                                          cursor: "pointer",
                                        },
                                        on: { click: _vm.goTheJob },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("setting.group.text2"))
                                        ),
                                      ]
                                    ),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.$t("setting.group.text3")) +
                                        "\n                  "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.$t("setting.group.title2")) +
                                        "\n                    "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "#1890ff",
                                          cursor: "pointer",
                                        },
                                        on: { click: _vm.goTheEnterprise },
                                      },
                                      [_vm._v("企业信息 ")]
                                    ),
                                    _vm._v("中进行修改\n                  "),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.$t("setting.group.title3"))
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "el-icon-question",
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "small",
                              icon: "el-icon-plus",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openBox("addDrawerIsShow", "add")
                              },
                            },
                          },
                          [_vm._v("新增")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex lh-center mt16" },
                      [
                        _c("div", { staticClass: "total-16" }, [
                          _vm._v("共 " + _vm._s(_vm.total) + " 条"),
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          staticStyle: { width: "250px" },
                          attrs: {
                            "prefix-icon": "el-icon-search",
                            clearable: "",
                            placeholder: "请输入姓名、电话号码",
                            size: "small",
                          },
                          on: { change: _vm.handleSearch },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleSearch($event)
                            },
                          },
                          model: {
                            value: _vm.formData.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "name", $$v)
                            },
                            expression: "formData.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading",
                          },
                        ],
                        staticClass: "table-container",
                      },
                      [
                        _c(
                          "el-table",
                          {
                            ref: "multipleTable",
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: _vm.tableData,
                              "tooltip-effect": "dark",
                              height: _vm.tableHeight,
                            },
                            on: {
                              "selection-change": _vm.handleSelectionChange,
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "name",
                                label: _vm.$t("toptable.name"),
                                "min-width": "100",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "flex lh-center" },
                                        [
                                          _c("img", {
                                            staticClass: "img",
                                            attrs: {
                                              src: scope.row.avatar,
                                              alt: "",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(_vm._s(scope.row.name)),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "frame.name",
                                label: _vm.$t("toptable.department"),
                                "min-width": "140",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return _vm._l(
                                      scope.row.frames,
                                      function (item, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "frame-name over-text",
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "icon-h" },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(item.name)
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          item.is_mastart ===
                                                            1 &&
                                                          scope.row.frames
                                                            .length > 1,
                                                        expression:
                                                          "item.is_mastart === 1 && scope.row.frames.length > 1",
                                                      },
                                                    ],
                                                    attrs: { title: "主部门" },
                                                  },
                                                  [_vm._v("(主)")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          item.is_admin == 1,
                                                        expression:
                                                          "item.is_admin == 1",
                                                      },
                                                    ],
                                                    staticClass: "guan",
                                                    attrs: { title: "主管" },
                                                  },
                                                  [_vm._v("(管)")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    )
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "job.name",
                                label: _vm.$t("toptable.post"),
                                "min-width": "110",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "phone",
                                label: _vm.$t("toptable.phone"),
                                "min-width": "110",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "join_time",
                                label: _vm.$t("toptable.jointime"),
                                "min-width": "100",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t("public.operation"),
                                width: "120",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "hasPermi",
                                              rawName: "v-hasPermi",
                                              value: [
                                                "hr:enterprise:group:edit",
                                              ],
                                              expression:
                                                "['hr:enterprise:group:edit']",
                                            },
                                          ],
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onEdit(scope.row.id)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.$t("public.edit")) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !scope.row.uid
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDelete(
                                                    scope.row.id,
                                                    scope.$index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t("public.delete")
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "page-fixed" },
                          [
                            _c("el-pagination", {
                              attrs: {
                                "page-size": _vm.formData.limit,
                                "current-page": _vm.formData.page,
                                "page-sizes": [15, 20, 30],
                                layout:
                                  "total,sizes, prev, pager, next, jumper",
                                total: _vm.total,
                              },
                              on: {
                                "current-change": _vm.pageChange,
                                "size-change": _vm.handleSizeChange,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("updataXls", {
        ref: "personBox",
        attrs: { "person-config": _vm.personConfig, "frame-id": _vm.frame_id },
      }),
      _vm._v(" "),
      _c("inviteesTable", {
        ref: "inviteesTableBox",
        on: {
          handleInvitees: _vm.handleInvitees,
          getQuantity: _vm.getQuantity,
        },
      }),
      _vm._v(" "),
      _c("editUser", { ref: "editUser", attrs: { "user-id": _vm.userId } }),
      _vm._v(" "),
      _c("dialogForm", {
        ref: "dialogForm",
        attrs: {
          "roles-config": _vm.rolesConfig,
          "form-data": _vm.formBoxConfig,
        },
        on: { isOk: _vm.isOk },
      }),
      _vm._v(" "),
      _c("UserDetails", {
        ref: "userDetails",
        attrs: { tabtypes: 1, actionType: "" },
        on: { getList: _vm.getList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }